import { Controller } from "@hotwired/stimulus";
import Coloris from "@melloware/coloris";

// Makes the entire inspector-color-field clickable: anywhere outside the
// hex text input or Coloris's swatch button forwards the click to the
// input so Coloris pops the picker.
export default class extends Controller {
  static targets = ["input"];

  open(event) {
    if (event.target.closest(".clr-field")) return;

    // Revert any other field's open picker so its leaked HSV state can't commit into the new input.
    const openInput = document.querySelector(
      ".inspector-color[data-coloris-open]",
    );
    if (openInput && openInput !== this.inputTarget) Coloris.close(true);

    if (event.target === this.inputTarget) return;
    this.inputTarget.click();
  }
}
